export default "__VITE_ASSET__3TVf7cVd__"